export default '/static/frontend/ReachDigital/12gobiking/dist/assets/seur-48600527.png'